<template>
  <span class="title-table-presentation-tooltip result-layout-tooltip ml-2">
    <b-button
      v-tooltip="{
        content :tooltipContent,
        delay : {show : 0 , hide : 600},
        html : true
      }"
      class="tooltip-btn"
    />
    <i class="fas fa-question-circle" />
  </span>
</template>

<script>
export default {
  computed: {
    tooltipContent() {
      return this.$i18nPresenter.t('thirdPartyAIInfoMessage', {
        openAI: '<a href="https://openai.com/enterprise-privacy/" style="color:white;text-decoration: underline;"  target="_blank">OpenAI</a>',
        groq: '<a href="https://groq.com/privacy" style="color:white;text-decoration: underline;"  target="_blank"> Groq</a>',
      })
    },
  },
}
</script>
